import { useEffect, useState } from 'react';

import { unwrapResult } from '@reduxjs/toolkit';
import format from 'date-fns/format';
import Alert from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Pagination } from '../../components/Pagination';

import { ProductForm } from './forms/ProductForm';

import {
  fetchListProduct,
  updateProduct,
  selectProductEntity,
} from './productSlice';

export function Product() {
  const dispatch = useDispatch();
  const product = useSelector(selectProductEntity);
  const [alert, setAlert] = useState(null);
  const [page, setPage] = useState(1);
  const [phone, setPhone] = useState('');
  const [productId, setProductId] = useState('');

  useEffect(() => {
    dispatch(fetchListProduct({ page }));
  }, [dispatch, page]);

  return (
    <Row>
      <Col>
        <h4>Danh Sách Sản Phẩm</h4>
        <Form
          inline
          onSubmit={(e) => {
            e.preventDefault();
            setPage(1);
            dispatch(fetchListProduct({ page: 1, productId, phone }));
          }}
        >
          <Form.Label htmlFor="searchFormProductId" srOnly>
            Mã serial
          </Form.Label>
          <Form.Control
            className="mb-2 mr-sm-2"
            id="searchFormProductId"
            placeholder="Nhập mã serial"
            value={productId}
            onChange={(e) => setProductId(e.target.value)}
          />
          <Form.Label htmlFor="searchFormPhone" srOnly>
            SDT
          </Form.Label>
          <Form.Control
            className="mb-2 mr-sm-2"
            id="searchFormPhone"
            placeholder="Nhập sdt khách hàng"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <Button type="submit" className="mb-2">
            Tìm kiếm
          </Button>
        </Form>
        <hr />
        <Table bordered responsive size="sm">
          <thead>
            <tr>
              <th>Serial</th>
              <th>Khách Hàng</th>
              <th>SKU</th>
              <th>Giá Mua</th>
              <th>Ngày Lắp Đặt</th>
              <th>Ngày Hết Hạn Bảo Hành</th>
              <th>Thao Tác</th>
            </tr>
          </thead>
          <tbody>
            {product.ids.map((id) => (
              <tr key={id}>
                <td>{product.entities[id].productId}</td>
                <td>{product.entities[id].customer.name}</td>
                <td>{product.entities[id].sku.skuName}</td>
                <td>
                  {new Intl.NumberFormat('vi-VN', {
                    style: 'currency',
                    currency: 'VND',
                  }).format(product.entities[id].purchasedPrice)}
                </td>
                <td>
                  {format(
                    new Date(product.entities[id].installationDate),
                    'dd/MM/yyyy'
                  )}
                </td>
                <td>
                  {format(
                    new Date(product.entities[id].warrantlyExpirationDate),
                    'dd/MM/yyyy'
                  )}
                </td>
                <td>
                  <Link
                    to={{
                      pathname: '/admin/product/edit',
                      state: product.entities[id],
                    }}
                  >
                    Chỉnh sửa
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={page}
          totalItem={product.total}
          onPageChange={(page) => setPage(page)}
        />
      </Col>
      <Col md={3}>
        <h4>Tạo Sản Phẩm</h4>
        <hr />
        <ProductForm
          alert={
            alert && <Alert variant={alert.variant}>{alert.content}</Alert>
          }
          onSubmit={async (data, e) => {
            setAlert(null);

            if (!data.installationDate || !data.installationDate) {
              return;
            }

            const installationDate = format(
              new Date(data.installationDate),
              'dd/MM/yyyy'
            );
            const warrantlyExpirationDate = format(
              new Date(data.warrantlyExpirationDate),
              'dd/MM/yyyy'
            );

            try {
              const result = await dispatch(
                updateProduct({
                  ...data,
                  purchasedPrice: Number(data.purchasedPrice),
                  installationDate,
                  warrantlyExpirationDate,
                })
              );

              unwrapResult(result);
              setAlert({ variant: 'success', content: 'Thành công!' });
              e.target.reset();
            } catch (e) {
              setAlert({ variant: 'danger', content: e.message });
            }
          }}
          values={{
            installationDate: format(new Date(), 'yyyy-MM-dd'),
            warrantlyExpirationDate: format(new Date(), 'yyyy-MM-dd'),
          }}
        />
      </Col>
    </Row>
  );
}
